import c from 'classnames';
import React from 'react';

import { TextColor, Typography } from '@repo/ui';
import { useProcessedActionPlanData } from '../hooks/useProcessedActionPlanData';
import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import { AgeGroup, getAgeGroup } from '@repo/utils';
import illustration from 'assets/images/summary/first-look/actionplan_categories_illustration_3.svg';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import styles from './ActionPlanCategories.module.css';
import slideStyles from './Slides.module.css';

export const ActionPlanSupplements: React.FC = () => {
  const { supplements: items, supplementsTotal: totalCount } =
    useProcessedActionPlanData();
  const remainingCount = totalCount - items.length;

  const { currentKit, currentTinyAccount } = useCurrentKitAndTinyAccount();
  const isAdult =
    getAgeGroup(currentKit?.age_at_sampling ?? 0) === AgeGroup.ADULT;

  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.actionPlanSupplements }}
    >
      <div className={styles.contentContainer}>
        <Typography variant='heading-xl' color={TextColor.GREEN}>
          Recommended supplements
        </Typography>

        {items.length > 0 ? (
          <>
            <ul className={styles.listContainer}>
              {items.map((item, index) => (
                <li key={index}>
                  <Typography variant='body-m'>{item}</Typography>
                </li>
              ))}
            </ul>
            {remainingCount > 0 && (
              <Typography variant='body-s' color={TextColor.GREEN}>
                +{remainingCount} more
              </Typography>
            )}
          </>
        ) : (
          <Typography variant='body-m'>
            No supplement recommendations available
          </Typography>
        )}
        <Typography variant='body-s'>
          View {isAdult ? 'your' : `${currentTinyAccount?.first_name}'s`} Action
          Plan for more details on each step.
        </Typography>
      </div>
      <div className={c(styles.bottom, styles.background, styles.background3)}>
        <img src={illustration} alt='supplement recommendations illustration' />
      </div>
    </div>
  );
};
